import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import EditorProps from './EditorProps'
import KendoEditorTool from '../KendoEditorTool'

import Deserialization from './Deserialization'
import FileBrowser from './FileBrowser'
import ImageBrowser from './ImageBrowser'
import Immutables from './Immutables'
import Messages from './Messages'
import PasteCleanup from './PasteCleanup'
import Pdf from './Pdf'
import Resizable from './Resizable'
import Serialization from './Serialization'

export default {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: EditorProps,
    mixins: [
        KendoBaseComponent,
        Deserialization,
        FileBrowser,
        ImageBrowser,
        Immutables,
        Messages,
        PasteCleanup,
        Pdf,
        Resizable,
        Serialization
    ],
    mounted() {
        var that = this

        that._resolveChildren()

        kendo.jQuery(that.$el).kendoEditor(that.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }

        that.kendoWidget().bind('change', () => {
            if(that.v3){
                that.$emit('update:modelValue', that.kendoWidget().value())
            } else {
                that.$emit('changemodel', that.kendoWidget().value())
            }
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoEditor()
        },
        _resolveChildren() {
            this.resolveChildren('tools', KendoEditorTool.name)
        }
    },
    model: {
        event: 'changemodel'
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-editor-vue-wrapper/src/KendoEditor/KendoEditorMixin.js